<div class="toast-msg-container"
      [ngClass]="{'show-message': showMsg, 'hide-message' : !showMsg,
      'warning-msg' : msgItems.msgType=='W','information-msg' : msgItems.msgType=='I',
      'error-msg' : msgItems.msgType=='E'}">
<div class="px-2 py-2 row" >
   <p style="font-size:large;">{{msgItems.msgTitle}}
      <span class="close-btn" (click)="hideMsg()">&times;</span></p> 
   
</div> 
<p class="px-2 py-1" style="font-style:italic;">{{msgItems.msg}}</p>      
</div>
